import { config } from 'config';
import { AxiosInstance, AxiosResponse } from 'axios';
import { AxiosClient, AxiosUtils } from 'api/AxiosClient/AxiosClient';
import * as Sentry from '@sentry/react';
import { SERVICE_DOWN } from 'api/errors';

type GeolocResponse = {
  zipcode: string;
  lat: number;
  lon: number;
  towns: string[];
};

class Geoloc {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = AxiosClient.get({
      baseURL: config.URL_GEOLOC_API,
    });
  }

  async getTownsFromZipCode(zipCode: string): Promise<GeolocResponse> {
    return this.client
      .get<GeolocResponse>(`v2/zipcodes/${zipCode}`)
      .then(r => r.data)
      .catch(e => {
        Sentry.captureException(e, {
          tags: {
            api: 'Geoloc',
            endpoint: 'v2/zipcodes',
            ...AxiosUtils.enrichTags(e),
          },
        });
        if (e.response) {
          const response: AxiosResponse<any> = e.response;
          if (response.status === 404) {
            return Promise.reject({ message: 'Code postal non trouvé' });
          }
          return Promise.reject({ message: response.data.message });
        }
        return Promise.reject({ message: SERVICE_DOWN });
      });
  }
}

export const GeolocService = new Geoloc();
